import React from 'react';
import { Link, Route, Redirect } from 'react-router-dom';
import { Card, StickyNavigation } from 'ui-toolkit';
import { IncomingChecksPage } from '../../pages/accounting/IncomingChecksPage';
import { IncomingWiresPage } from '../../pages/accounting/IncomingWiresPage';
import { IncomingAchsPage } from '../../pages/accounting/IncomingAchsPage';
import { UnrestrictedInternalTransfersPage } from '../../pages/accounting/UnrestrictedInternalTransfersPage';
import { JournalEntriesPage } from '../../pages/accounting/JournalEntriesPage';
import { UserProfileContainer } from '../../components/userProfile/UserProfileContainer';
import { Text, Tabs, ThemeConstellation, Flex } from '@zillow/constellation';
import { ThemeProvider } from 'styled-components';

export const AccountingRouter: React.FC = () => (
  <Route
    path="/spa/admin/accounting"
    render={({ match: { url } }) => {
      const tabs = [
        { id: 'incoming-transactions', text: 'Incoming Transactions', to: `${url}/incoming_transactions` },
        { id: 'journal-entries', text: 'Journal Entries', to: `${url}/journal_entries` },
        { id: 'internal-transfers', text: 'Unrestricted Internal Transfers', to: `${url}/internal_transfers` },
      ];

      return (
        <div className="p-4">
          <ThemeProvider theme={ThemeConstellation as any}>
            <StickyNavigation activeMain={'Accounting'} profile={<UserProfileContainer />} />
            <Card contentPadding="16px 16px 0 16px">
              <Flex display="flex" gap={1}>
                <Tabs>
                  <Tabs.List aria-label="Accounting Navigation">
                    {tabs.map((tab) => (
                      <Tabs.Tab
                        key={tab.id}
                        id={tab.id}
                        as={Link}
                        to={tab.to}
                        aria-selected={window.location.pathname.includes(tab.to)}
                        className={'!pb-2 !pt-1'}
                      >
                        <Text>{tab.text}</Text>
                      </Tabs.Tab>
                    ))}
                  </Tabs.List>
                </Tabs>
              </Flex>
            </Card>
            <div className="pt-4">
              <Route path="/spa/admin/accounting" exact={true}>
                <Redirect to="/spa/admin/accounting/incoming_transactions" />
              </Route>
              <Route path={`${url}/incoming_transactions`} exact={true}>
                <Redirect to={`${url}/incoming_transactions/wires`} />
              </Route>
              <Route path={`${url}/incoming_transactions/wires`} component={IncomingWiresPage} />
              <Route path={`${url}/incoming_transactions/checks`} component={IncomingChecksPage} />
              <Route path={`${url}/incoming_transactions/achs`} component={IncomingAchsPage} />
              <Route path={`${url}/internal_transfers`} component={UnrestrictedInternalTransfersPage} />
              <Route path={`${url}/journal_entries`} component={JournalEntriesPage} exact={true} />
              <Route path={`${url}/journal_entries/deleted`} component={JournalEntriesPage} />
            </div>
          </ThemeProvider>
        </div>
      );
    }}
  />
);
